import React from 'react';
import AvailabilityManagerHub from '../components/Professional/AvailabilityManagerHub';
import { Calendar } from 'lucide-react';

/**
 * Dedicated Availability Management Page
 * Provides a clean, focused interface for professionals to manage their availability
 */
const AvailabilityPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900" style={{ padding: '32px 16px' }}>
      <div className="mx-auto" style={{ maxWidth: '1280px' }}>
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <Calendar className="h-8 w-8 text-gray-900 dark:text-white" />
            <h1 className="text-3xl font-normal text-gray-900 dark:text-white">
              Availability Management
            </h1>
          </div>
          <p className="text-base text-gray-600 dark:text-gray-400">
            Set your available time slots for coffee chats and consultations
          </p>
        </div>

        {/* Availability Manager */}
        <AvailabilityManagerHub />
      </div>
    </div>
  );
};

export default AvailabilityPage;
